import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-404f3ef0")

_pushScopeId("data-v-404f3ef0")
const _hoisted_1 = {
  class: "df-middle px-20",
  style: {"height":"40px"}
}
const _hoisted_2 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheSelectBar = _resolveComponent("TheSelectBar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TheSelectBar, {
      options: _ctx.resolutions,
      class: "c-title"
    }, {
      default: _withId(({item, active, select}) => [
        _createVNode("div", {
          class: ["py-4 t-left resolution toggle__line-btn", [...(active ? ['active', 'c-primary'] : [])]],
          onClick: ($event: any) => (_ctx.change(item, select)),
          style: {"max-width":"50px"}
        }, _toDisplayString(item.label), 11, ["onClick"])
      ]),
      _: 1
    }, 8, ["options"]),
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
})